import type { ReactElement, ReactNode } from "react";
import { isFragment } from "react-is";

/**
 * If props.children is a single Fragment, then it returns the children of this Fragment instead.
 * If this is already an array of ReactNode, is return the current array of ReactNode.
 * Will help if you need to use `React.Children.forEach()` for instance.
 */
export const getChildrenFromFragment = (node: ReactNode): ReactNode =>
  isFragment(node) ? (node as ReactElement).props.children : node;
